var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2969 8.29688H0.703125C0.314789 8.29688 0 8.61166 0 9C0 9.38834 0.314789 9.70312 0.703125 9.70312H17.2969C17.6852 9.70312 18 9.38834 18 9C18 8.61166 17.6852 8.29688 17.2969 8.29688Z",
    fill: "#4B9BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2969 2.67188H0.703125C0.314789 2.67188 0 2.98666 0 3.375C0 3.76334 0.314789 4.07812 0.703125 4.07812H17.2969C17.6852 4.07812 18 3.76334 18 3.375C18 2.98666 17.6852 2.67188 17.2969 2.67188Z",
    fill: "#4B9BF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2969 13.9219H0.703125C0.314789 13.9219 0 14.2367 0 14.625C0 15.0133 0.314789 15.3281 0.703125 15.3281H17.2969C17.6852 15.3281 18 15.0133 18 14.625C18 14.2367 17.6852 13.9219 17.2969 13.9219Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMenu);
export default __webpack_public_path__ + "static/media/open-menu.66cb9bc95be8f5d39a5b3f23875cf03a.svg";
export { ForwardRef as ReactComponent };